export default "__VITE_ASSET__BD9f9iz8__"